import {observer} from 'mobx-react';
import {Dispatch, SetStateAction} from 'react';
import {useStoreContext} from '../../../../../../store/store-context';
import {AdminBillingActive} from './admin-billing-components/billing-active/billing-active';
import {AdminBillingNotActive} from './admin-billing-components/billing-not-active/billing-not-active';
import {deriveBillingState} from '@utils/billing-state';
import {
  GeneralPage,
  GeneralPageIntro,
} from '../admin-workspace-components/admin-workspace-general.styles';
interface IAdminBillingSetup {
  setShowStarterPlanCTA: Dispatch<SetStateAction<boolean>>;
}
export const AdminBillingSetup = observer(
  ({setShowStarterPlanCTA}: IAdminBillingSetup) => {
    const {
      authStore: {auth},
      billingsStore: {showNonActiveBilling},
    } = useStoreContext();
    const billingState = deriveBillingState(auth?.user?.workspace?.billing);
    const hasManagedSubscription = ['active', 'past_due', 'canceling'].includes(
      billingState,
    );

    return (
      <GeneralPage>
        <GeneralPageIntro>
          <h1>Billing</h1>
          <p>
            Manage your subscription, seats, payment method, and billing
            activity.
          </p>
        </GeneralPageIntro>
        {hasManagedSubscription && !showNonActiveBilling ? (
          <AdminBillingActive />
        ) : (
          <AdminBillingNotActive
            setShowStarterPlanCTA={setShowStarterPlanCTA}
          />
        )}
      </GeneralPage>
    );
  },
);
